import { format } from 'date-fns';
import { enGB, fr } from 'date-fns/locale';

export const getFormattedMonth = (date: Date, locale: Locale | undefined) =>
  format(date, 'MMMM', { locale: locale?.code === 'en-GB' ? enGB : fr });
